module.exports = __webpack_public_path__ + "static/media/video-camera-white.49506428.svg";